
const CareRecipientIdType = Symbol();

export class CareRecipientId {
    [CareRecipientIdType]: any;
    readonly value: string;

    private constructor(careRecipientId: string) {
        this.value = careRecipientId;
    }

    static fromString(careRecipientId: string): CareRecipientId {
        return new CareRecipientId(careRecipientId);
    }
}
